export default "__VITE_ASSET__Dj9m6SzW__"